import { apiClient } from './axios';
import type {
    DictionaryReviewPage,
    DictionaryReviewStatus,
    DictionaryReviewSummary,
} from '../types/dictionaryReview';

export interface DictionaryReviewQueueParams {
    status?: DictionaryReviewStatus;
    headLang?: string;
    meaningLang?: string;
    page?: number;
    size?: number;
}

export interface DictionaryReviewSummaryParams {
    headLang?: string;
    meaningLang?: string;
}

export const dictionaryReviewApi = {
    getQueue: (params: DictionaryReviewQueueParams) =>
        apiClient.get<DictionaryReviewPage>('/admin/dictionary/validation/review-queue', {
            ...(params.status && params.status !== 'ALL' ? { status: params.status } : {}),
            headLang: params.headLang ?? 'en',
            meaningLang: params.meaningLang ?? 'ko',
            page: params.page ?? 0,
            size: params.size ?? 20,
        }),

    getSummary: (params: DictionaryReviewSummaryParams) =>
        apiClient.get<DictionaryReviewSummary>('/admin/dictionary/validation/review-queue/summary', {
            headLang: params.headLang ?? 'en',
            meaningLang: params.meaningLang ?? 'ko',
        }),
};
